import { InputValidators } from '@pwr/input-validators';
import i18n from '@/plugins/i18n';

const inputValidators = new InputValidators({ i18n });

export default inputValidators;
